import { useSnackbar } from 'notistack'
import { createContext, useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'

const authContext = createContext()

export function ProvideAuth({ children }) {
    const auth = useProvideAuth()
    return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

export const useAuth = () => {
    return useContext(authContext)
}

function useProvideAuth() {
    const [user, setUser] = useState(null)
    const [isAuth, setisAuth] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const history = useHistory()

    const loginMutation = async (params) => {
        const response = await fetch(`${process.env.REACT_APP_URL}/api/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        })

        if (!response.ok) {
            throw new Error('Error')
        } else {
            const { data } = await response.json()
            return data
        }
    }

    const { mutate, isLoading } = useMutation(loginMutation, {
        onSuccess: (data) => {
            localStorage.setItem('token', data.access_token)
            localStorage.setItem('user', JSON.stringify(data.user))
            setisAuth(true)
            setUser(data.user)
            if (data.user.role_id === 1) {
                history.push('/dashboard/users/all')
            } else if (data.user.role_id === 2) {
                history.push('/dashboard/disposisi/keluar')
            } else {
                history.push('/dashboard/disposisi/masuk')
            }
        },
        onError: () => {
            enqueueSnackbar('Kombinasi email dan password salah', { variant: 'error' })
        },
    })

    const logOut = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        setisAuth(false)
        history.push('/')
    }

    return { isAuth, user, logOut, mutate, isLoading }
}
